document.addEventListener('DOMContentLoaded', function () {
  // Use Glightbox instead of default Elementor lightbox
  // Because of the weird bug which is causing Elementor lightbox not work with GTM
  // https://wordpress.org/support/topic/elementor-lightbox-conflict-with-gtm/
  const lightbox = GLightbox({ selector: '[data-elementor-open-lightbox], .woocommerce-product-gallery__wrapper a' });
})
